<template>
    <div style="width: 100%;">
        <el-form ref="fw_form" :model="form" :rules="rules" label-position="left" label-width="200px"
                style="width: 50%; margin-left: 0%;">
            <el-form-item label="固件版本" prop="version">
                <el-input-number v-model="form.version" :min="1" :max="65535" label="APP固件版本号" :precision="0"></el-input-number>
            </el-form-item>

            <el-form-item label="升级说明" prop="description">
                <el-input type="textarea" v-model="form.description" clearable size="mini" style="width: 90%;" placeholder="升级版本的说明信息"></el-input>
            </el-form-item>

            <el-form-item label="配置字段" prop="pre_cofig">
                <el-input type="textarea" v-model="form.pre_config" clearable size="mini" style="width: 90%;" placeholder="升级版本的配置字段"></el-input>
            </el-form-item>

            <el-form-item label="固件支持的版本" prop="support_pairs">
                <div v-for="(version_pair, index) in form.support_pair" :key="index" class="version_pair">
                    <el-row>
                        <el-col :span="7" style="margin-right: 10px;">
                            <el-select v-model="version_pair[0]" placeholder="硬件版本" value="">
                                <el-option v-for="option in all_hw_versions" :label="option" :key="option" :value="option"></el-option>
                                <!-- <el-option key="硬件版本test" value="1"></el-option> -->
                            </el-select>
                        </el-col>
                        <el-col :span="7" style="margin-right: 10px;">
                            <el-select v-model="version_pair[1]" placeholder="BOOT版本" value="">
                                <el-option v-for="(boot_ver, index) in all_boot_versions" :label="boot_ver" :key="boot_ver" :value="boot_ver"></el-option>
                                <!-- <el-option label="boot固件版本test" value="1"></el-option> -->
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-button @click="removeVersionPair(index)" type="danger">删除</el-button>
                        </el-col>
                    </el-row>
                </div>
                <el-button @click="addVersionPair" type="primary">添加支持的版本</el-button>
            </el-form-item>

            <el-form-item label="已保存的固件文件" v-show="file_exist != ''">
				<span>{{ file_exist }}</span>
			</el-form-item>

            <el-form-item label="选择固件文件" prop="upload">
                <el-upload class="upload-demo" ref="upload" :accept="acceptFile()" action="" :file_list="fileList"
                        :auto-upload="false" :on-change="fileChange" :on-remove="fileRemove" :http-request="httpRequest">
                    <el-button size="small" type="primary">选择文件</el-button>
                    <div slot="tip" class="el-upload-tip">只能上传bin文件</div>
                </el-upload>
            </el-form-item>

        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="submit" type="primary">{{ this.upload_btn_text }}</el-button>
        </span>
    </div>
</template>

<style lang="css" scoped>
.version_pair {
    margin-bottom: 20px;
}
</style>

<script lang="js">
import { uploadAppFW, getHardwares, getAllBootFirmwares, getAppFWSupports, updateAppFW } from '@/api';

export default {
    data() {
        var validateFile = (rules, value, callback) => {
            if (this.fileList.length < 1) {
                callback(new Error('请选择文件'));
            } else {
                callback();
            }
        }

        return {
            is_details: false,
            upload_btn_text: '',
            file_exist: '',
            fileList: [],
            all_hw_versions: [],    // 所有的硬件版本
            all_boot_versions: [],  // 所有的boot固件
            form: {
                version: 0,
                description: "",
                pre_config: "",
                fw_file: [],
                support_pair: [],
            },

            rules: {
                version: [{ required: true, message: '硬件版本号1-65535'}],
                description: [{ required: true, message: '请填写描述信息'}],
                fw_file: [{ required: true, validator: validateFile, message: '请选择上传文件'}]
            }
        }
    },
    mounted() {
        // 区分是新增还是详情
        const app_fw = this.$route.query.app_fw;

        getHardwares().then(hardwares => {
            hardwares.forEach(ele => {
                this.all_hw_versions.push(ele.version);
            });
            console.log('all hw versions: ', this.all_hw_versions);
        }).catch(error => {
            this.unsupportOperation(error);
        });

        getAllBootFirmwares().then(res => {
            if (res.status === 200 && res.data.code === 200) {
                this.all_boot_versions = res.data.data;
                console.log('all boot versions: ', this.all_boot_versions);
            }
        }).catch(error => {
            this.unsupportOperation(error);
        });
        
        if (!app_fw) {
            this.is_details = false;
            this.upload_btn_text = '上传固件';
        }
        else {
            console.log('页面传递的参数app_fw: ', app_fw);
            this.is_details = true;
            this.upload_btn_text = '更新固件';

            this.form.description = app_fw.description;
            this.form.version = app_fw.version;
            this.form.pre_config = app_fw.pre_config;
            // this.fileList = [app_fw.url];
            this.file_exist = app_fw.url;

            // 查询接口获取app固件的支持信息
            getAppFWSupports(app_fw.version).then(res => {
                if (res.status === 200 && res.data.code === 200) {
                    console.log('app支持信息: ', res.data.data.hw_boot);
                    this.form.support_pair = res.data.data.hw_boot;
                }
            }).catch(error => {
                this.unsupportOperation(error);
            });
        }
    },
    methods: {
        submit() {
            this.$refs.fw_form.validate((valid) => {
                if (valid) {
                    console.log('fileList = ', this.fileList, ', valid = ', valid);
                    if (this.fileList.length > 0) {
                        this.$refs.upload.submit();
                    }
                    else {
                        var fd = new FormData();
                        fd.append('version', this.form.version);
                        fd.append('description', this.form.description);
                        fd.append('pre_config', this.form.pre_config);
                        
                        var supports = []
                        this.form.support_pair.forEach(pair => {
                            console.log('pair:', pair);
                            supports.push([pair[0], pair[1]]);
                        });
                        fd.append('support_pair', JSON.stringify(supports)) // 保存支持版本信息[[hw_ver, boot_ver], ...[]]，注意排除none
                        // console.info('更新app固件的formdata: ', fd);

                        var that = this;
                        updateAppFW(fd).then(res => {
                        console.log('更新app固件的结果:', res);
                            if (res.status === 200 && res.data.code === 200) {
                                that.open2();
                                that.$router.push('/beltappfirmware');
                            } else {
                                that.open4(res.data.msg + '[' + res.data.code + ']');
                            }
                        }).catch(error => {
                            this.unsupportOperation(error);
                        });
                    }
                }
            })
        },
        httpRequest(param) {
            // 只有当选中上传的文件时，才会在submit方法的回调中调用这个方法，因此patch如果没有文件，直接发送patch请求
            console.log('httpRequest param: ', param);
            var fileObj = param.file;
            var fd = new FormData();
            fd.append('version', this.form.version);
            fd.append('description', this.form.description);
            fd.append('pre_config', this.form.pre_config);
            fd.append('fw_file', fileObj);

            var supports = []
            this.form.support_pair.forEach(pair => {
                console.log('pair:', pair);
                supports.push([pair[0], pair[1]]);
            });
            fd.append('support_pair', JSON.stringify(supports)) // 保存支持版本信息[[hw_ver, boot_ver], ...[]]，注意排除none

            var that = this;
            if (!this.is_details) {
                uploadAppFW(fd).then(res => {
                    console.log('upload app fw resp: ', res);
                    if (res.data.code === 200) {
                        that.open2();
                        that.$router.push('/beltappfirmware')
                    } else {
                        that.open4(res.data.msg + '[' + res.data.code + ']');
                    }
                }).catch(error => {
                    this.unsupportOperation(error);
                });
            } else {
                updateAppFW(fd).then(res => {
                    console.log('更新app固件的结果:', res);
                    if (res.status === 200 && res.data.code === 200) {
                        that.open2();
                        that.$router.push('/beltappfirmware');
                    } else {
                        that.open4(res.data.msg + '[' + res.data.code + ']');
                    }
                }).catch(error => {
                    this.unsupportOperation(error);
                });
            }
        },
        open2() {
            this.$message({ message: '上传成功', type: 'success' });
        },
        open4(errStr) {
            this.$message.error('上传失败:' + errStr);
        },
        unsupportOperation(errStr) {
			this.$message.error('该操作当前尚不支持,请等待接口更新后再试', errStr)
		},
        acceptFile() {
            return '.bin';
        },
        fileChange(file, fileList) {
            this.fileList = [file];
            console.log('fileChange: ', file, fileList, this.fileList);
        },
        fileRemove(file, fileList) {
            this.fileList = [];
            console.log('fileRemove: ', file, fileList, this.fileList);
        },
        addVersionPair() {
            this.form.support_pair.push([]);
            console.log('添加支持的版本信息', 'version pair = ', this.form.support_pair);
        },
        removeVersionPair(index) {
            this.form.support_pair.splice(index, 1);
            console.log('删除支持的版本信息', 'version pair = ', this.form.support_pair);
        }
    }
}
</script>